export default "__VITE_ASSET__CwTJrCQw__"